export const queryKeys = {
  marketplace: {
    all: ['marketplace'] as const,
    catalog: () => [...queryKeys.marketplace.all, 'catalog'] as const,
    products: (workspaceKey?: string) =>
      [...queryKeys.marketplace.all, 'products', workspaceKey || 'all'] as const,
  },
  project: (projectId: number) => ['project', projectId] as const,
  workspaceRoot: (projectId: number) => ['workspace', projectId] as const,
  workspace: (projectId: number, blueprintId?: number | null, tabId?: number | null) =>
    [...queryKeys.workspaceRoot(projectId), blueprintId || 0, tabId || 0] as const,
  recipeAttributes: (blueprintId: number, tabId: number) =>
    ['recipe-attributes', blueprintId, tabId] as const,
};
